Array.prototype.clear = function () {
    this.splice(0, this.length);
};
//Array.prototype.add = function ( this: Array<any>, item ): void {
//    this.push( item );
//};
Array.prototype.hasRows = function () {
    return this.length > 0;
};
Array.prototype.remove = function (predicate, replaceItem) {
    if (typeof predicate === 'object') {
        const idx = this.findIndex(x => x === predicate);
        if (idx > -1) {
            if (replaceItem)
                this.splice(idx, 1, replaceItem);
            else
                this.splice(idx, 1);
            return true;
        }
    }
    else if (typeof predicate === 'function') {
        const idx = this.findIndex(predicate);
        if (idx > -1) {
            if (replaceItem)
                this.splice(idx, 1, replaceItem);
            else
                this.splice(idx, 1);
            return true;
        }
    }
};
